import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => createStyles({
  apartmentIconInfo: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    '& > div:not(:last-child)': {},
    '& > div': {
      width: '50%',
      marginBottom: '2px',
      overflow: 'hidden',
      overflowWrap: 'anywhere',
      '& > img': {
        marginRight: '4px',
        width: '24px',
        height: '24px',
      },
    },
  },
  iconInfo: {
    fontSize: '12px',
    display: 'flex',
    alignItems: 'center',
    '& .iconInfoText': {
      lineHeight: '14px',
    },
  },
}));
